$(document).on(
  "tqht_mansite_floatleft rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

   
  }
);
